(function () {
	'use strict';
	angular.module('app.core')
		.service('userConfigUtilsService', userConfigUtilsService);
	
	userConfigUtilsService.$inject = [];
	function userConfigUtilsService() {
		var userConfig = globalConfig.user;
		return {
			getSitesForCustomer: getSitesForCustomer,
			getClearToBuildSingleLevelEnabledForUser: getClearToBuildSingleLevelEnabledForUser,
			getClearToBuildMultiLevelEnabledForUser: getClearToBuildMultiLevelEnabledForUser,
			getUsePoConfirmationsForSite: getUsePoConfirmationsForSite
		};

		function getSitesForCustomer() {
			return Object.keys(globalConfig.user.authFacts)
				.filter(function(site) {
					return globalConfig.user.authFacts[site].customerNdx === globalConfig.customer.id;
				});
		}

		function getClearToBuildSingleLevelEnabledForUser(){
			return getSitesForCustomer().filter(function filterToCtbSingleLevelSites(site) {
				return userConfig && userConfig.authFacts[site].settings.GenerateClearToBuild === '1';
			}).length > 0;
		}

		function getClearToBuildMultiLevelEnabledForUser(){
			return getSitesForCustomer().filter(function filterToCtbMultiLevelSites(site) {
				return userConfig && userConfig.authFacts[site].settings.GenerateClearToBuildFlattenedReqs === '1';
			}).length > 0;
		}

		function getUsePoConfirmationsForSite(factoryNdx){
			return userConfig.authFacts[factoryNdx].settings.usePoConfirmations;
		}
	}
})();
